/* GearNas — small theme-wide enhancements (mobile drawer, header scroll state) */
(function () {
  'use strict';

  // Mobile drawer toggle
  document.addEventListener('click', function (e) {
    const open = e.target.closest('[data-gn-drawer-open]');
    const close = e.target.closest('[data-gn-drawer-close]');
    if (open) {
      const id = open.getAttribute('data-gn-drawer-open');
      const drawer = document.getElementById(id);
      if (drawer) drawer.classList.add('is-open');
    }
    if (close) {
      const drawer = close.closest('.gn-mobile-drawer');
      if (drawer) drawer.classList.remove('is-open');
    }
    // close on backdrop click
    if (e.target.classList && e.target.classList.contains('gn-mobile-drawer')) {
      e.target.classList.remove('is-open');
    }
  });

  // Esc closes drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.gn-mobile-drawer.is-open').forEach(d => d.classList.remove('is-open'));
    }
  });

  // Header scroll state — adds subtle shadow when scrolled
  const header = document.querySelector('.gn-header--sticky');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Newsletter graceful submit shim (no-op if Shopify form exists)
  document.querySelectorAll('.gn-newsletter-form[data-noop]').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      form.innerHTML = '<p class="gn-muted" style="margin:0">شكراً لاشتراكك ✨</p>';
    });
  });

  // ── Locale + Currency dropdown (.gn-locale-drop) ─────────────────────────
  // Handles open/close, DYNAMIC language URL building, and currency switching.

  function gnDropClose(el) {
    el.classList.remove('is-open');
    var t = el.querySelector('[data-gn-locale-trigger]');
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  /**
   * Build the correct URL for a locale switch.
   *
   * @param {string} targetCode  — ISO code to switch to, e.g. 'ar'
   * @param {string} defaultCode — store's primary locale ISO code, e.g. 'en'
   * @param {string[]} allCodes  — every published locale code
   * @returns {string}           — e.g. '/ar/products/test' or '/products/test'
   */
  function gnBuildLocaleUrl(targetCode, defaultCode, allCodes) {
    var path = window.location.pathname;

    // Strip any existing locale prefix from the current path
    var stripped = path;
    for (var i = 0; i < allCodes.length; i++) {
      var code = allCodes[i].trim();
      if (!code) continue;
      if (path === '/' + code) {
        stripped = '/';
        break;
      }
      if (path.startsWith('/' + code + '/')) {
        stripped = path.slice(code.length + 1); // keep the leading /
        break;
      }
    }
    if (!stripped.startsWith('/')) stripped = '/' + stripped;

    // Prepend target locale prefix (default locale has no prefix in Shopify)
    if (targetCode === defaultCode) {
      return stripped;
    }
    return '/' + targetCode + stripped;
  }

  document.addEventListener('click', function (e) {
    // ── language link click — POST locale change then navigate ───────────
    var langLink = e.target.closest('[data-gn-locale-code]');
    if (langLink) {
      e.preventDefault();
      var targetCode  = langLink.getAttribute('data-gn-locale-code');
      var drop        = langLink.closest('[data-gn-locale-drop]');
      var defaultCode = drop ? (drop.getAttribute('data-gn-default-locale') || 'en') : 'en';
      var allCodes    = drop ? (drop.getAttribute('data-gn-locale-codes') || '').split(',') : [];
      var targetUrl   = gnBuildLocaleUrl(targetCode, defaultCode, allCodes);

      // Grab the hidden form (it carries Shopify's CSRF / form_type tokens).
      // We POST locale_code + return_to so Shopify sets the locale session
      // cookie AND redirects to the correct page — not just the homepage.
      var curForm = drop
        ? drop.querySelector('.gn-locale-drop__cur-form')
        : document.querySelector('.gn-locale-drop__cur-form');

      if (curForm) {
        var fd = new FormData(curForm);
        fd.set('locale_code', targetCode);   // tell Shopify which locale
        fd.delete('currency_code');           // don't touch the currency
        fd.set('return_to', targetUrl);       // land on THIS page, not homepage
        // fetch absorbs the server-side redirect; we navigate ourselves
        fetch('/localization', { method: 'POST', body: fd, redirect: 'manual' })
          .then(function () { window.location.href = targetUrl; })
          .catch(function () { window.location.href = targetUrl; });
      } else {
        // No form found — fall back to direct URL navigation
        window.location.href = targetUrl;
      }
      return;
    }

    var trigger    = e.target.closest('[data-gn-locale-trigger]');
    var insideDrop = e.target.closest('[data-gn-locale-drop]');

    // ── currency button click ─────────────────────────────────────────────
    var currBtn = e.target.closest('[data-gn-currency]');
    if (currBtn && !currBtn.disabled) {
      var code = currBtn.getAttribute('data-gn-currency');
      var dropEl = currBtn.closest('[data-gn-locale-drop]');
      var form = dropEl
        ? dropEl.querySelector('.gn-locale-drop__cur-form')
        : document.querySelector('.gn-locale-drop__cur-form');
      if (form) {
        var codeField   = form.querySelector('[name="currency_code"]');
        var returnField = form.querySelector('[name="return_to"]');
        if (codeField)   codeField.value   = code;
        if (returnField) returnField.value = window.location.pathname;
        form.submit();
      }
      return;
    }

    // ── click outside → close all ─────────────────────────────────────────
    if (!insideDrop) {
      document.querySelectorAll('.gn-locale-drop.is-open').forEach(gnDropClose);
      return;
    }

    // ── trigger click → toggle open/closed ───────────────────────────────
    if (trigger) {
      var parentDrop = trigger.closest('[data-gn-locale-drop]');
      var wasOpen    = parentDrop.classList.contains('is-open');
      document.querySelectorAll('.gn-locale-drop.is-open').forEach(gnDropClose);
      if (!wasOpen) {
        parentDrop.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
      e.stopPropagation();
    }
  });

  // Esc closes locale + currency dropdowns
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.gn-locale-drop.is-open').forEach(gnDropClose);
    }
  });

  // fixSplideArrows removed — arrow icons are driven purely by CSS class
  // (.splide__arrow--prev / --next) with html[dir] overrides for RTL.
  // The old getBoundingClientRect approach fired before Splide had
  // positioned the arrows, setting data-gn-side="left" on both buttons.

  document.addEventListener('DOMContentLoaded', () => {
    // (no arrow-fix timeouts needed)
  });
})();


